<footer class="footer">
    <div class="container">
       <!--  <nav class="pull-left">
            <ul>
                <li>
                    <a href="#">
                        Home
                    </a>
                </li>
                <li>
                    <a href="#">
                        Company
                    </a>
                </li>
                <li>
                    <a href="#">
                        Portfolio
                    </a>
                </li>
                <li>
                    <a href="#">
                        Blog
                    </a>
                </li>
            </ul>
        </nav> -->
        <div class="copyright float-right">
            &copy;
            {{test | date: 'yyyy'}}
            Powered by <a href="https://www.linksoluciones.com/">Link Soluciones</a>
        </div>
    </div>
</footer>